import * as unitsOfMeasurementService from '../../services/unitsOfMeasurement';
import * as actionTypes from './actionTypes';

const fetchData = (startAction, successAction, errorAction, serviceMethod, dataKey) => {
	return (dispatch) => {
		dispatch(startAction());
		return serviceMethod()
			.then(({ data }) => {
				dispatch(successAction({ [dataKey]: data ?? [] }));
				return data;
			})
			.catch((error) => {
				dispatch(errorAction(error));
			});
	};
};

export const getUnitsOfMeasurement = () => {
	return fetchData(
		startFetchingUnitsOfMeasurement,
		getUnitsOfMeasurementSuccess,
		getUnitsOfMeasurementError,
		unitsOfMeasurementService.getUnitsOfMeasurement,
		'unitsOfMeasurement'
	);
};

const startFetchingUnitsOfMeasurement = () => {
	return { type: actionTypes.START_FETCHING_UNITS_OF_MEASUREMENT };
};

const getUnitsOfMeasurementSuccess = (payload) => {
	return { type: actionTypes.GET_UNITS_OF_MEASUREMENT_SUCCESS, payload };
};

const getUnitsOfMeasurementError = (error) => {
	return { type: actionTypes.GET_UNITS_OF_MEASUREMENT_ERROR, payload: error };
};

export const removeUnitsOfMeasurement = () => {
	return { type: actionTypes.REMOVE_UNITS_OF_MEASUREMENT };
};
